import { HttpErrorResponse } from '@angular/common/http';

/** The text for a refused current password, or null for any other answer. */
export function currentPasswordRefusal(code: string): string | null {
    switch (code) {
        case 'INVALID_PASSWORD':
            return 'That password is not correct.';
        case 'USER_LOCKED':
            return 'Too many attempts. Please try again in a few minutes.';
        default:
            return null;
    }
}

/**
 * What the two-factor screens show for a failed call. A refused password comes back as a code in a JSON body, a failed
 * 2FA call as a text body; a server error's body may be a whole page, so it is never shown.
 */
export function twoFactorAuthError(response: HttpErrorResponse): string {
    const refusal = currentPasswordRefusal(response?.error?.message);
    if (refusal) {
        return refusal;
    }
    const isClientError = response?.status >= 400 && response?.status < 500;
    return isClientError && typeof response.error === 'string' && response.error ? response.error : 'Something went wrong. Please try again.';
}
